import { Edito } from "@hermes/api-model-editorial";
import { MenuEntry, MenuEntryType } from "@hermes/api-model-shell";
import { MenuEntryItem } from "@hermes/states/menu";

/**
 * Safe access to editorial data in menu entry
 */
export const getEdito = (entry: MenuEntry): Edito | undefined => {
    if (
        (entry.type === MenuEntryType.gridMenuEntry ||
            entry.type === MenuEntryType.landitoMenuEntry ||
            entry.type === MenuEntryType.ecommerceStoryMenuEntry) &&
        entry.edito !== undefined &&
        Object.keys(entry.edito).length > 0
    ) {
        return entry.edito;
    }
    return undefined;
};

export const getEntryPimCode = (item: MenuEntryItem): string | undefined => {
    if (item.type === MenuEntryType.storyMenuEntry) {
        return "MISSING_PIM_CODE";
    }
    return item.pimCode;
};

/**
 * Utility function to clean the name of a MenuEntryItem from special characters.
 * It keeps only uppercase letters, numbers, and the "&" symbol.
 * This is specifically used for entries of type "story", which don't have a pimCode,
 * so we rely on the cleaned name to send consistent analytics data from the menu.
 */
export const getFormattedEntryName = (
    item: MenuEntryItem,
): string | undefined =>
    item.name
        ?.toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036F]/g, "")
        .replace(/[^\d&A-Z]/g, "");

export const isGridMenuEntry = (menuEntry: MenuEntry): boolean =>
    menuEntry.type === MenuEntryType.gridMenuEntry;

export const isStoryMenuEntry = (menuEntry: MenuEntry): boolean =>
    menuEntry.type === MenuEntryType.storyMenuEntry;

export const getCleanUrlPath = (fullPath: string): string => {
    if (!fullPath) {
        return "";
    }
    return fullPath.split(/[#?]/)[0];
};
